import { ROUTES_APLICATION } from '@constants/routes-aplication.constants';
import { UserTypeEnum } from '@enums/user-type.enum';
import { ApplicationModules } from '@enums/application-modules.enum';
import { MenuConfigModel } from '@core/models/outros/menu-config.model';

export const MENU_EXAMS: MenuConfigModel = {
  id: ApplicationModules.EXAMS,
  icon: 'quiz',
  name: 'Foto Biometria',
  onlyAssociated: false,
  text: 'Organize os agendamentos de <strong>foto biometria</strong>, os <strong>locais</strong> onde ocorrem ou <strong>bloqueie horários</strong>.',
  profilesToShowItems: [
    UserTypeEnum.ADMINISTRADOR,
    UserTypeEnum.OPERADOR_N1,
    UserTypeEnum.INSTRUTOR,
    UserTypeEnum.SUPERVISOR,
    UserTypeEnum.ADMINISTRADOR_DETRAN
  ],
  submenus: [
    // {
    //   name: 'Agendamento de Exames',
    //   onlyAssociated: false,
    //   profilesToShowItems: [
    //     UserTypeEnum.ADMINISTRADOR,
    //     UserTypeEnum.OPERADOR_N1,
    //     UserTypeEnum.INSTRUTOR,
    //     UserTypeEnum.SUPERVISOR,
    //     UserTypeEnum.ADMINISTRADOR_DETRAN
    //   ],
    //   route: `/${ROUTES_APLICATION.exams.path}/${ROUTES_APLICATION.exams.schedulingExams}`,
    // },

    {
      name: 'Agendamento de Foto Biometria',
      onlyAssociated: false,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.OPERADOR_N1,
        UserTypeEnum.SUPERVISOR
      ],
      route: `/${ROUTES_APLICATION.exams.path}/${ROUTES_APLICATION.exams.photoBiometrics}`,
    },
    {
      name: 'Bloqueio de Disponibilidade de Foto Biometria',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR
      ],
      route: `/${ROUTES_APLICATION.exams.path}/${ROUTES_APLICATION.exams.bloqueiofotobiometria}`,
    },
    // {
    //   name: 'Bloqueio de Disponibilidade de Exames',
    //   onlyAssociated: true,
    //   profilesToShowItems: [
    //     UserTypeEnum.ADMINISTRADOR
    //   ],
    //   route: `/${ROUTES_APLICATION.exams.path}/${ROUTES_APLICATION.exams.block}`,
    // },
    // {
    //   name: 'Disponibilidade de Exame',
    //   onlyAssociated: true,
    //   profilesToShowItems: [
    //     UserTypeEnum.ADMINISTRADOR
    //   ],
    //   route: `/${ROUTES_APLICATION.exams.path}/${ROUTES_APLICATION.exams.availability}`,
    // },
    {
      name: 'Disponibilidade de Foto Biometria',
      onlyAssociated: false,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR
      ],
      route: `/${ROUTES_APLICATION.exams.path}/${ROUTES_APLICATION.exams.disponibilidadefotobiometria}`,
    },
    // {
    //   name: 'Bloqueio de Disponibilidade de Exames',
    //   onlyAssociated: true,
    //   profilesToShowItems: [
    //     UserTypeEnum.ADMINISTRADOR
    //   ],
    //   route: `/${ROUTES_APLICATION.exams.path}/${ROUTES_APLICATION.exams.block}`,
    // },
    // {
    //   name: 'Gerenciamento de Bioexame',
    //   onlyAssociated: true,
    //   profilesToShowItems: [
    //     UserTypeEnum.ADMINISTRADOR,
    //     UserTypeEnum.ADMINISTRADOR_DETRAN,
    //     UserTypeEnum.OPERADOR_N1,
    //     UserTypeEnum.SUPERVISOR
    //   ],
    //   route: `/${ROUTES_APLICATION.exams.path}/${ROUTES_APLICATION.exams.bioexame}`,
    // },
    // {
    //   name: 'Locais de Exames',
    //   onlyAssociated: true,
    //   profilesToShowItems: [
    //     UserTypeEnum.ADMINISTRADOR
    //   ],
    //   route: `/${ROUTES_APLICATION.exams.path}/${ROUTES_APLICATION.exams.local}`,
    // },

    {
      name: 'Locais de Foto Biometria',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR
      ],
      route: `/${ROUTES_APLICATION.exams.path}/${ROUTES_APLICATION.exams.localfotobiometria}`,
    },

  ]
}
